/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./src/assets/js/delivery-widget.js ***!
  \******************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DeliveryModal = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DeliveryModal, _HTMLElement);
  var _super = _createSuper(DeliveryModal);
  function DeliveryModal() {
    var _this;
    _classCallCheck(this, DeliveryModal);
    _this = _super.call(this);
    _this.closeButton = _this.querySelector('.delivery-widget__drawer-close');
    _this.overlay = _this.querySelector('.delivery-widget__drawer-overlay');
    _this.modalWrapper = _this.querySelector('.delivery-widget__drawer-wrapper');
    _this.submitBtn = _this.querySelector('.form-submit-btn');
    _this.body = document.body;
    _this.anotherDateWrapper = _this.querySelector('.another-date-wrapper');
    _this.dateInputs = _this.querySelectorAll('input[name="date"]');
    _this.timeInputs = _this.querySelectorAll('input[name="time"]');
    _this.deliveryWidgets = document.querySelectorAll('delivery-widget');
    _this.atcBtn = document.querySelector('.header__icon--cart');
    _this.product = _this.dataset.product ? _this.dataset.product : null;
    _this.dateInputItem = _this.querySelector('input[type="date"]');
    return _this;
  }
  _createClass(DeliveryModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setEventListeners();
      //this.addTodayButton(); // Call this first to add "Today" button and set its event listener
      this.loadLocalStorage();
      this.toggleDateVisibility(); // Call this last to ensure event listeners are set correctly
    }
  }, {
    key: "openCart",
    value: function openCart() {
      this.atcBtn.click();
    }
  }, {
    key: "addTodayButton",
    value: function addTodayButton() {
      var _this2 = this;
      var container = this.querySelector('.delivery-widget__drawer-dates-wrapper--date');
      var now = new Date();
      var twoHoursFromNow = new Date(now.getTime() + 2 * 60 * 60 * 1000);
      var availableTimes = this.querySelectorAll('input[name="time"]');
      var hasAvailableSlot = false;
      availableTimes.forEach(function (time) {
        var timeWindow = time.value.split(' ')[1]; // "з 9:00 до 21:00" -> "9:00"
        var startHour = timeWindow.split(':')[0]; // "9:00" -> "9"
        var endHour = time.value.split(' ')[3]; // "з 9:00 до 21:00" -> "21:00"
        var startTime = new Date();
        var endTime = new Date();
        startTime.setHours(parseInt(startHour, 10), 0, 0, 0);
        endTime.setHours(parseInt(endHour, 10), 0, 0, 0);
        if (startTime >= twoHoursFromNow || endTime >= twoHoursFromNow) {
          hasAvailableSlot = true;
        } else {
          time.nextElementSibling.style.display = 'none';
        }
      });
      if (hasAvailableSlot) {
        var today = now.toISOString().split('T')[0];
        var input = document.createElement('input');
        input.type = 'radio';
        input.id = today;
        input.name = 'date';
        input.value = today;
        input.style.display = 'none';
        var label = document.createElement('label');
        label.htmlFor = today;
        label.className = 'tw-cursor-pointer';
        label.innerHTML = "\n                <span style=\"border: 1px solid;\" class=\"tw-flex tw-transition-all tw-px-[14px] tw-py-[6px] tw-border tw-border-[#1B1B1B] tw-rounded-[40px] tw-text-font14 tw-font-medium tw-text-[#1B1B1B]\">\n                    \u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\n                </span>\n            ";
        container.insertBefore(label, container.firstChild);
        container.insertBefore(input, label);
        input.addEventListener('change', function () {
          _this2.hidePastTimeSlots();
        });
      }
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      var openCart = this.openCart.bind(this);
      fetch(window.location.href).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector('cart-drawer').innerHTML = doc.querySelector('cart-drawer').innerHTML;
        document.querySelector('cart-drawer').classList.remove('is-empty');
      })["catch"](function (err) {
        console.warn('Something went wrong.', err);
      }.bind(this));
    }
  }, {
    key: "showAllTimeSlots",
    value: function showAllTimeSlots() {
      this.timeInputs.forEach(function (time) {
        time.nextElementSibling.style.display = '';
      });
    }
  }, {
    key: "toggleDateVisibility",
    value: function toggleDateVisibility() {
      var _this3 = this;
      this.dateInputs = this.querySelectorAll('input[name="date"]'); // Update dateInputs

      this.dateInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.value === 'another') {
            _this3.anotherDateWrapper.classList.remove('tw-hidden');
          } else {
            if (!_this3.anotherDateWrapper.contains(document.activeElement)) {
              _this3.anotherDateWrapper.classList.add('tw-hidden');
            }
          }
          var today = new Date().toISOString().split('T')[0];
          if (input.value === today) {
            _this3.hidePastTimeSlots();
          } else {
            _this3.showAllTimeSlots();
          }
        });
      });
      this.timeInputs.forEach(function (checkbox, index) {
        checkbox.addEventListener('change', function () {
          if (index === 0) {
            if (checkbox.checked) {
              _this3.timeInputs.forEach(function (cb, idx) {
                if (idx !== 0) cb.checked = false;
              });
            }
          } else {
            _this3.timeInputs[0].checked = false;
          }
        });
      });
    }
  }, {
    key: "hidePastTimeSlots",
    value: function hidePastTimeSlots() {
      var now = new Date();
      var twoHoursFromNow = new Date(now.getTime() + 2 * 60 * 60 * 1000);
      this.timeInputs.forEach(function (time) {
        var timeWindow = time.value.split(' ')[1]; // "з 9:00 до 21:00" -> "9:00"
        var startHour = timeWindow.split(':')[0]; // "9:00" -> "9"
        var endHour = time.value.split(' ')[3]; // "з 9:00 до 21:00" -> "21:00"
        var startTime = new Date();
        var endTime = new Date();
        startTime.setHours(parseInt(startHour, 10), 0, 0, 0);
        endTime.setHours(parseInt(endHour, 10), 0, 0, 0);
        if (startTime >= twoHoursFromNow || endTime >= twoHoursFromNow) {
          time.nextElementSibling.style.display = '';
        } else {
          time.nextElementSibling.style.display = 'none';
          time.checked = false; // Uncheck the hidden time slot
        }
      });
    }
  }, {
    key: "saveSelection",
    value: function saveSelection() {
      var isAnotherDaySelected = this.querySelector('input[name="date"]:checked').value === 'another';
      var selectedDate = this.querySelector('input[name="date"]:checked').value;
      if (isAnotherDaySelected) {
        selectedDate = this.querySelector('#other').value; // Use the custom date from the "Another Day" text input
      }

      var selectedTimes = _toConsumableArray(this.querySelectorAll('input[name="time"]:checked')).map(function (input) {
        return input.value;
      });
      var storageObj = {
        date: selectedDate,
        time: selectedTimes,
        timestamp: new Date().toDateString(),
        isAnotherDaySelected: isAnotherDaySelected
      };
      localStorage.setItem('deliverySelection', JSON.stringify(storageObj));
    }
  }, {
    key: "loadLocalStorage",
    value: function loadLocalStorage() {
      var savedSelection = JSON.parse(localStorage.getItem('deliverySelection'));
      if (savedSelection && savedSelection.timestamp === new Date().toDateString()) {
        this.anotherDateWrapper.classList.add('tw-hidden');
        if (savedSelection.isAnotherDaySelected) {
          //this.querySelector('input[value="another"]').checked = true;
          var anotherDateInput = this.querySelector('input[value="another"]');
          if (anotherDateInput) {
            anotherDateInput.checked = true;
          }

          this.anotherDateWrapper.classList.remove('tw-hidden');
          this.querySelector('#other').value = savedSelection.date;
        } else {
          this.dateInputs.forEach(function (input) {
            if (input.value === savedSelection.date) {
              input.checked = true;
            }
          });

          // Check if today was selected
          var today = new Date().toISOString().split('T')[0];
          if (savedSelection.date === today) {
            this.querySelector("input[id=\"".concat(today, "\"]")).checked = true;
            this.hidePastTimeSlots(); // Hide past slots if today is selected
          } else {
            this.showAllTimeSlots(); // Show all slots if not today
          }
        }

        this.timeInputs.forEach(function (input) {
          if (savedSelection.time.includes(input.value)) {
            input.checked = true;
          }
        });
      } else {
        this.anotherDateWrapper.classList.add('tw-hidden');
        if (this.dateInputs.length > 0) this.dateInputs[0].checked = true;
        if (this.timeInputs.length > 0) this.timeInputs.forEach(function (input, index) {
          if (index === 0) input.checked = true;
        });
        this.showAllTimeSlots(); // Show all slots if no saved selection
      }
    }
  }, {
    key: "saveSelectionToCart",
    value: function saveSelectionToCart() {
      var selectedDate = this.querySelector('input[name="date"]:checked').value === 'another' ? this.querySelector('#other').value : this.querySelector('input[name="date"]:checked').value;
      var selectedTimes = _toConsumableArray(this.querySelectorAll('input[name="time"]:checked')).map(function (input) {
        return input.value;
      }).join(', ');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Selected Delivery Date': selectedDate,
            'Selected Delivery Times': selectedTimes
          }
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        return console.log('Cart attributes updated:', data);
      })["catch"](function (error) {
        return console.error('Error updating cart attributes:', error);
      });
    }
  }, {
    key: "addToCart",
    value: function addToCart(productId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: productId,
            quantity: 1
          }]
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log(data);
        return data;
      })["catch"](function (error) {
        return console.error('Error:', error);
      });
    }
  }, {
    key: "fetchCart",
    value: function fetchCart() {
      fetch('/cart.js').then(function (response) {
        return response.json();
      }).then(function (data) {
        return console.log(data);
      })["catch"](function (error) {
        return console.error('Error:', error);
      });
    }
  }, {
    key: "formSubmit",
    value: function formSubmit() {
      var _this4 = this;
      this.saveSelection();
      this.saveSelectionToCart();
      this.closeModal();

      // Update delivery window text immediately after submission
      var selectedDate = this.querySelector('input[name="date"]:checked').value === 'another' ? this.querySelector('#other').value : this.querySelector('input[name="date"]:checked').value;
      var selectedTimes = _toConsumableArray(this.querySelectorAll('input[name="time"]:checked')).map(function (input) {
        return input.value;
      }).join(', ');

      // Format the date display
      var date = new Date(selectedDate);
      var displayDate = '';
      var today = new Date();
      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      var dayAfterTomorrow = new Date(today);
      dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
      if (date.toDateString() === today.toDateString()) {
        displayDate = 'Сьогодні';
      } else if (date.toDateString() === tomorrow.toDateString()) {
        displayDate = 'Завтра';
      } else if (date.toDateString() === dayAfterTomorrow.toDateString()) {
        displayDate = 'Післязавтра';
      } else {
        var dayOfWeek = date.toLocaleString('uk-UA', {
          weekday: 'short'
        });
        var day = date.getDate();
        var month = date.getMonth() + 1;
        displayDate = "".concat(dayOfWeek, " ").concat(day, ".").concat(month < 10 ? '0' + month : month);
      }
      var displayText = "".concat(displayDate, " ").concat(selectedTimes);
      document.querySelectorAll('.delivery-widget__input-value').forEach(function (el) {
        el.textContent = displayText;
      });
      setTimeout(function () {
        if (_this4.product != null) {
          _this4.checkProductInCartAndAddIfNeeded();
        }
        if (typeof window.checkFields === 'function') {
          window.checkFields();
        }
      }, 1000);
      setTimeout(function () {
        _this4.deliveryWidgets.forEach(function (widget) {
          widget.updateWidgetFromLocalStorage();
        });
      }, 1800);
    }
  }, {
    key: "checkProductInCartAndAddIfNeeded",
    value: function checkProductInCartAndAddIfNeeded() {
      var _this5 = this;
      fetch('/cart.js').then(function (response) {
        return response.json();
      }).then(function (cart) {
        var isProductInCart = cart.items.some(function (item) {
          return item.id.toString() === _this5.product;
        });
        if (!isProductInCart && _this5.product) {
          _this5.addToCart(_this5.product).then(function () {
            // this.renderCart();
          });
        }
      })["catch"](function (error) {
        return console.error('Error:', error);
      });
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this6 = this;
      this.overlay.onclick = function (event) {
        if (event.target === event.currentTarget) {
          _this6.closeModal();
        }
      };
      this.closeButton.onclick = function () {
        return _this6.closeModal();
      };
      this.querySelector('form').addEventListener('submit', function (event) {
        event.preventDefault();
        _this6.formSubmit();
      });
      this.formatDate();
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      var dtToday = new Date();
      var month = dtToday.getMonth() + 1;
      var day = dtToday.getDate();
      var year = dtToday.getFullYear();
      if (month < 10) month = '0' + month.toString();
      if (day < 10) day = '0' + day.toString();
      var maxDate = year + '-' + month + '-' + day;
      this.dateInputItem.setAttribute('min', maxDate);
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventListeners();
      this.toggleDateVisibility();
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.modalWrapper.style.display = "flex";
      this.overlay.style.display = 'block';
      this.body.style.overflow = 'hidden';
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modalWrapper.style.display = "none";
      this.overlay.style.display = 'none';
      this.body.style.overflow = 'auto';
    }
  }]);
  return DeliveryModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('delivery-modal', DeliveryModal);
var DeliveryWidget = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(DeliveryWidget, _HTMLElement2);
  var _super2 = _createSuper(DeliveryWidget);
  function DeliveryWidget() {
    var _this7;
    _classCallCheck(this, DeliveryWidget);
    _this7 = _super2.call(this);
    _this7.modal = document.querySelector('delivery-modal');
    _this7.triggerBtn = _this7.querySelector('.trigger__button');
    _this7.widgetText = _this7.querySelector('.delivery-widget__input-text');
    _this7.widgetValue = _this7.querySelector('.delivery-widget__input-value');
    return _this7;
  }
  _createClass(DeliveryWidget, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
      // Check for saved delivery window on page load
      var savedSelection = JSON.parse(localStorage.getItem('deliverySelection'));
      if (savedSelection && savedSelection.timestamp === new Date().toDateString()) {
        var date = new Date(savedSelection.date);
        var displayDate = '';
        var today = new Date();
        var tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        var dayAfterTomorrow = new Date(today);
        dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
        if (date.toDateString() === today.toDateString()) {
          displayDate = 'Сьогодні';
        } else if (date.toDateString() === tomorrow.toDateString()) {
          displayDate = 'Завтра';
        } else if (date.toDateString() === dayAfterTomorrow.toDateString()) {
          displayDate = 'Післязавтра';
        } else {
          var dayOfWeek = date.toLocaleString('uk-UA', {
            weekday: 'short'
          });
          var day = date.getDate();
          var month = date.getMonth() + 1;
          displayDate = "".concat(dayOfWeek, " ").concat(day, ".").concat(month < 10 ? '0' + month : month);
        }
        var displayText = "".concat(displayDate, " ").concat(savedSelection.time.join(', '));
        if (this.widgetValue) {
          this.widgetValue.textContent = displayText;
        }
      } else {
        // If no saved selection or expired, show default text
        if (this.widgetValue) {
          this.widgetValue.textContent = 'Коли приїхати курʼєру';
        }
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this8 = this;
      this.triggerBtn.addEventListener('click', function () {
        if (_this8.checkSavedDateAndTime()) {
          _this8.modal.openCart();
        } else {
          _this8.openModal();
        }
      });
      this.widgetText.addEventListener('click', function () {
        _this8.openModal();
      });
    }
  }, {
    key: "checkSavedDateAndTime",
    value: function checkSavedDateAndTime() {
      var savedSelection = JSON.parse(localStorage.getItem('deliverySelection'));
      if (!savedSelection) return false;
      var currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      var savedDate = new Date(savedSelection.date);
      savedDate.setHours(0, 0, 0, 0);
      return savedDate >= currentDate;
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventListeners();
      this.updateWidgetFromLocalStorage();
    }
  }, {
    key: "updateWidgetFromLocalStorage",
    value: function updateWidgetFromLocalStorage() {
      var savedSelection = JSON.parse(localStorage.getItem('deliverySelection'));
      if (savedSelection && savedSelection.timestamp === new Date().toDateString()) {
        var currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        var selectedDate = new Date(savedSelection.date);
        selectedDate.setHours(0, 0, 0, 0);
        var timeDifference = selectedDate - currentDate;
        var daysDifference = timeDifference / (1000 * 3600 * 24);
        var displayDate = '';
        if (daysDifference === 1) {
          displayDate = 'Завтра';
        } else if (daysDifference === 2) {
          displayDate = 'Післязавтра';
        } else {
          var dayOfWeek = selectedDate.toLocaleString('uk-UA', {
            weekday: 'short'
          });
          var day = selectedDate.getDate();
          var month = selectedDate.getMonth() + 1;
          displayDate = "".concat(dayOfWeek, " ").concat(day, ".").concat(month < 10 ? '0' + month : month);
        }
        var times = savedSelection.time.join(', ');
        var displayText = "".concat(displayDate, " ").concat(times);
        this.querySelector('.delivery-widget__input-value').textContent = displayText;
      }
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.modal.openModal();
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modal.closeModal();
    }
  }]);
  return DeliveryWidget;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('delivery-widget', DeliveryWidget);
/******/ })()
;